import { Alert } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'

/**
 * Warns that neither of a parameter's CSV exports accounts for its amendments.
 */
export const ParameterAmendmentsExportWarningAlert = () => {
  const translate = useTranslate()

  return (
    <Alert
      severity="warning"
      title={translate('parameterViewer.values.amendments.exportWarningTitle')}
      className="max-w-full!"
    >
      {translate('parameterViewer.values.amendments.exportWarning')}
    </Alert>
  )
}
